import { isSafariV14OrBelow, setAspectRatio } from '@tvg/fuse-utils';
import React from 'react';
import styled, { css } from 'styled-components';
import StyledProductcard from './styled-simple-product-card';

const { useEffect, useRef } = React;

const propTypes = {};
const defaultProps = {};

const animatedGradient = css`
	background: linear-gradient(
		-45deg,
		var(--color-global-grey400),
		var(--color-global-grey300),
		var(--color-global-grey400),
		var(--color-global-grey500)
	);
	background-size: 400% 400%;
	animation: gradient 4s ease infinite;

	@keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
`;

const SkeletonImg = styled.div.attrs({
	className: 'simple-product-card__skeleton-image',
})`
	width: 100%;
	aspect-ratio: 3 /4;
	margin: 0 0 var(--spacing-global-space4);
	${animatedGradient}
`;

const SkeletonBrand = styled.div.attrs({
	className: 'simple-product-card__skeleton-brand',
})`
	width: 30%;
	height: var(--font-line-height-m1); /*line-height*/
	${animatedGradient}
	margin: 0 0 var(--spacing-global-space2);
`;

const SkeletonTitle = styled.div.attrs({
	className: 'simple-product-card__skeleton-title',
})`
	margin: 0 0 var(--spacing-global-space3);

	&::before,
	&::after {
		content: '';
		display: block;
		height: var(--font-line-height-m1);
		${animatedGradient}
	}
	&:before {
		margin: 0 0 1px;
		width: 100%;
	}
	&:after {
		width: 40%;
	}
`;

const SkeletonPrice = styled.div.attrs({
	className: 'simple-product-card__skeleton-price',
})`
	height: var(--spacing-global-space7);
	margin-bottom: var(--spacing-global-space4);
	width: 30%;
	${animatedGradient}
`;

const SkeletonPrevPrice = styled.div.attrs({
	className: 'simple-product-card__skeleton-previous-price',
})`
	height: var(--spacing-global-space6);
	width: 30%;
	${animatedGradient}
	margin-bottom: var(--spacing-global-space5);
`;

function SkeletonCardComponent(props) {
	const skeletonImgRef = useRef();

	useEffect(() => {
		const isSafari = isSafariV14OrBelow();

		// At first render, if safari browser version 14 or below is detected set aspect ratio of image due to CSS aspect-ratio not being supported
		if (isSafari) setAspectRatio(skeletonImgRef.current, 'height', 3 / 4);
	}, []);

	return (
		<StyledProductcard
			{...props}
			as="div"
			className="fuse-product-card fuse-product-card--skeleton"
			data-testid="product-card-skeleton"
		>
			<SkeletonImg data-testid="product-card-skeleton__image" ref={skeletonImgRef} />
			<SkeletonBrand data-testid="product-card-skeleton__price" />
			<SkeletonTitle data-testid="product-card-skeleton__title" />
			<SkeletonPrice
				data-testid="product-card-skeleton__price"
				className="fuse-product-card__price"
			/>
			<SkeletonPrevPrice
				data-testid="product-card-skeleton__prev-price"
				className="fuse-product-card__prev-price"
			/>
		</StyledProductcard>
	);
}

SkeletonCardComponent.propTypes = propTypes;
SkeletonCardComponent.defaultProps = defaultProps;

export default SkeletonCardComponent;
